import { render, staticRenderFns } from "./BrandedI18n.vue?vue&type=template&id=0e64e511&"
import script from "./BrandedI18n.vue?vue&type=script&lang=ts&"
export * from "./BrandedI18n.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports